import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Config from '../config/config'
import util from '../util/util'
import { SDKRegister } from '../util/weixin'

import Index from '@/pages/index'
import Report from '@/pages/report'
import QrcodeIndex from '@/pages/qrcode/index'
import Result from '@/pages/qrcode/result'
import Group from '@/pages/qrcode/group'
import QrcodeError from '@/pages/qrcode/error'

// 抽奖页面，可能会有多个
import AwardDraw from '@/pages/award/draw'
import AwardDraw1 from '@/pages/award/draw1'
import AwardDraw2 from '@/pages/award/draw2'
import AwardDraw3 from '@/pages/award/draw3'
import AwardDraw4 from '@/pages/award/draw4'
import AwardDraw5 from '@/pages/award/draw5'
import AwardXiangyun from '@/pages/award/xiangyun'
import AwardQingyun from '@/pages/award/qingyun'
import AwardQingyunKuCun from '@/pages/award/qingyun-kucun'
import AwardRongyao from '@/pages/award/rongyao'
import AwardRongyao2025 from '@/pages/award/rongyao2025'
import AwardGuose from '@/pages/award/guose'
import AwardSiluqing from '@/pages/award/siluqing'
import AwardGeneral from '@/pages/award/general'

import Award from '@/pages/award'

import User from '@/pages/user/index'
import UserDetails from '@/pages/user/userDetails'
import PhoneBind from '@/pages/user/phoneBind'
import AwardLog from '@/pages/user/award/log'
import Address from '@/pages/user/address/index'
import AddressEdit from '@/pages/user/address/edit'
import Feedback from '@/pages/user/feedback'
import AwardDetail from '@/pages/user/award/detail'
import AwardReceive from '@/pages/user/award/receive'
import Store from '@/pages/store'
import ReportList from '@/pages/user/report/index'
import ReportDetail from '@/pages/user/report/detail'
import Subscribe from '@/pages/user/subscribe'

// 店铺
import ShopRegister from '@/pages/shop/register'
import ShopVerify from '@/pages/shop/verify'
import ShopSubscribe from '@/pages/shop/subscribe'

import ShopIndex from '@/pages/shop/index'
import ShopDetails from '@/pages/shop/details'

import ResellerRegister from '@/pages/reseller/register'
import ResellerSubscribe from '@/pages/reseller/subscribe'

// 开瓶记录
import DecapRecord from '@/pages/decap/index'

// 最新活动
import Activity from '@/pages/activity/index'

// 测试页面
import Test from '@/pages/test/index'

import qs from 'qs'
import axios from '@/http'
import { Toast } from 'vant'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      name: 'Index',
      component: Index
    },
    {
      path: '/test',
      name: 'Test',
      component: Test,
      meta: {
        title: '测试页面'
      }
    },
    {
      path: '/report',
      name: 'Report',
      component: Report,
      meta: {
        title: '消费者信息反馈'
      }
    },
    {
      path: '/shop/index',
      name: 'ShopIndex',
      component: ShopIndex,
      meta: {
        title: '附近门店'
      }
    },
    {
      path: '/shop/details',
      name: 'ShopDetails',
      component: ShopDetails,
      meta: {
        title: '门店详情'
      }
    },
    {
      path: '/qrcode/result',
      name: 'Result',
      component: Result
    },
    {
      path: '/qrcode/error',
      name: 'QrcodeError',
      component: QrcodeError
    },

    {
      path: '/user',
      name: 'User',
      component: User,
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/user/userDetails',
      name: 'UserDetails',
      component: UserDetails,
      meta: {
        title: '编辑个人信息'
      }
    },
    {
      path: '/user/phone/bind',
      name: 'PhoneBind',
      component: PhoneBind,
      meta: {
        title: '绑定手机号'
      }
    },
    {
      path: '/user/award/log',
      name: 'AwardLog',
      component: AwardLog,
      meta: {
        title: '我的中奖纪录'
      }
    },
    {
      path: '/decap/index',
      name: 'DecapRecord',
      component: DecapRecord,
      meta: {
        title: '开瓶记录'
      }
    },
    {
      path: '/activity/index',
      name: 'Activity',
      component: Activity,
      meta: {
        title: '最新活动'
      }
    },
    {
      path: '/user/address',
      name: 'Address',
      component: Address,
      meta: {
        title: '收货地址'
      }
    },
    {
      path: '/user/address/edit',
      name: 'AddressEdit',
      component: AddressEdit,
      meta: {
        title: ''
      },
      beforeEnter: (to, from, next) => {
        // 设置默认收货地址
        if (to.params.id) {
          document.title = '编辑收货地址'
        } else {
          document.title = '新增收货地址'
        }
        next()
      }
    },
    {
      path: '/user/award/receive',
      name: 'AwardReceive',
      component: AwardReceive,
      beforeEnter: (to, from, next) => {
        // 设置默认收货地址
        if (!store.state.address) {
          store.dispatch('setAddress', { address: {}})
          const url = '/user/address/?default=true'
          axios.get(url).then(res => {
            if (!res.code && res.data.total) {
              const payload = { address: res.data.records[0] }
              store.dispatch('setAddress', payload)
            }
          })
          next()
        } else {
          next()
        }
      }
    },
    {
      path: '/user/award/detail',
      name: 'AwardDetail',
      component: AwardDetail
    },
    {
      path: '/user/report',
      name: 'ReportList',
      component: ReportList
    },
    {
      path: '/user/report/detail',
      name: 'ReportDetail',
      component: ReportDetail
    },
    {
      path: '/award',
      name: 'Award',
      component: Award
    },
    {
      path: '/award/draw',
      name: 'AwardDraw',
      component: AwardDraw
    },
    {
      path: '/award/draw1',
      name: 'AwardDraw1',
      component: AwardDraw1
    },
    {
      path: '/award/draw2',
      name: 'AwardDraw2',
      component: AwardDraw2
    },
    {
      path: '/award/draw3',
      name: 'AwardDraw3',
      component: AwardDraw3
    },
    {
      path: '/award/draw4',
      name: 'AwardDraw4',
      component: AwardDraw4
    },
    {
      path: '/award/draw5',
      name: 'AwardDraw5',
      component: AwardDraw5
    },
    {
      path: '/award/xiangyun',
      name: 'AwardXiangyun',
      component: AwardXiangyun
    },
    {
      path: '/award/qingyun',
      name: 'AwardQingyun',
      component: AwardQingyun
    },
    {
      path: '/award/qingyun-kucun',
      name: 'AwardQingyunKuCun',
      component: AwardQingyunKuCun
    },
    {
      path: '/award/rongyao',
      name: 'AwardRongyao',
      component: AwardRongyao
    },
    {
      path: '/award/rongyao2025',
      name: 'AwardRongyao2025',
      component: AwardRongyao2025
    },
    {
      path: '/award/guose',
      name: 'AwardGuose',
      component: AwardGuose
    },
    {
      path: '/award/siluqing',
      name: 'AwardSiluqing',
      component: AwardSiluqing
    },
    {
      path: '/award/general',
      name: 'AwardGeneral',
      component: AwardGeneral
    },
    {
      path: '/user/feedback',
      name: 'Feedback',
      component: Feedback,
      meta: {
        title: '问题反馈'
      }
    },
    {
      path: '/user/subscribe',
      name: 'Subscribe',
      component: Subscribe
    },
    {
      path: '/store',
      name: 'Store',
      component: Store
    },
    {
      path: '/reseller/register',
      name: 'ResellerRegister',
      component: ResellerRegister,
      meta: {
        title: '经销商注册'
      }
    },
    {
      path: '/reseller/subscribe',
      name: 'ResellerSubscribe',
      component: ResellerSubscribe,
      meta: {
        title: '经销商小程序'
      }
    },
    {
      path: '/shop/register',
      name: 'ShopRegister',
      component: ShopRegister,
      meta: {
        title: '国花荟终端'
      }
    },
    {
      path: '/shop/verify',
      name: 'ShopVerify',
      component: ShopVerify,
      meta: {
        title: '国花荟终端'
      }
    },
    {
      path: '/shop/subscribe',
      name: 'ShopSubscribe',
      component: ShopSubscribe,
      meta: {
        title: '国花荟终端'
      }
    },
    {
      path: '/g/:serial',
      name: 'Group',
      component: Group,
      meta: {
        keepAlive: true,
        title: '国花荟终端'
      }
    },
    {
      path: '/:serial',
      name: 'QrcodeIndex',
      component: QrcodeIndex
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// 定义全局的钩子
router.beforeEach((to, from, next) => {
  // 设置title
  var title = to.meta.title ? to.meta.title : Config.SITE_TITLE
  window.document.title = title
  // 不在微信里面，跳转到提示页面
  // if (to.name === 'QrcodeError') {
  //   return next()
  // } else if (!util.isWechat()) {
  //   return next({ name: 'QrcodeError', params: { errMsg: '请在微信中打开' }})
  // }
  // 授权回调页面不再跳转
  if (to.query.code) {
    return next()
  }
  // 如果没有微信授权,去授权
  if ((store.state.token && to.path.indexOf('/shop/') === -1) || (to.path.indexOf('/shop/') !== -1 && store.state.shopOpenId)) {
    if (util.isAndroid()) {
      store.dispatch('disableJssdk').then(() => {
        return next()
      })
    } else {
      next()
    }
  } else {
    // 做网页授权，需要删除原有的code
    var redirect_uri = util.removeUrlParam(window.location.href, 'code')
    var appId = Config.appId
    if (to.path.indexOf('/shop/') !== -1) {
      appId = Config.shopMpAppId
      redirect_uri = Config.baseUrl + to.path
    }
    var auth_url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri=' + redirect_uri + '&response_type=code&scope=snsapi_userinfo&state=0#wechat_redirect'
    window.location.href = auth_url
    return next()
  }
})

router.afterEach((to, from) => {
  // 店铺注册页面获取shopOpenId
  if (to.path.indexOf('/shop/') !== -1 && to.query.code) {
    return store.dispatch('getShopOpenId', { code: to.query.code }).then(() => {
      // jssdk签名
      const webUrl = Config.baseUrl + to.fullPath
      SDKRegister(webUrl, [], function() {
        store.dispatch('enableJssdk')
      })
    })
  }
  // jssdk配置
  if (store.state.token) {
    // jssdk未配置或者安卓手机都要再签名
    if (!store.state.jssdkEnabled || util.isAndroid()) {
      // jssdk签名
      const webUrl = Config.baseUrl + to.fullPath
      SDKRegister(webUrl, [], function() {
        store.dispatch('enableJssdk')
      })
    }
    return
  }
  // 判断是否存在网页授权的
  if (to.query.code) {
    // 微信用户授权登陆
    var params = { 'code': to.query.code, 'scope': 'snsapi_userinfo' }
    // base授权
    axios.post('/user/login/', qs.stringify(params)).then(function(res) {
      if (!res.code) {
        var payload = res.data
        console.log(payload, '+++++++')
        store.dispatch('login', payload).then(() => {
          // jssdk签名
          // 不存在手机号时 跳转绑定
          // const webUrl = store.state.userInfo.mobile ? Config.baseUrl + to.fullPath : Config.baseUrl + "/user/phone/bind"
          const webUrl = Config.baseUrl + to.fullPath
          SDKRegister(webUrl, [], function() {
            store.dispatch('enableJssdk')
          })
        })
      } else {
        Toast(res.message)
        // 当前页面的code已过期，重新授权
        var redirect_uri = util.removeUrlParam(window.location.href, 'code')
        var appId = Config.appId
        if (to.path === '/shop/register') {
          appId = Config.shopMpAppId
          redirect_uri = Config.baseUrl + to.path
        }
        var auth_url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri=' + redirect_uri + '&response_type=code&scope=snsapi_userinfo&state=0#wechat_redirect'
        window.location.href = auth_url
      }
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js